import React, { ChangeEvent, ReactNode } from 'react';

const AloRadioButton: React.FC<RadioButtonProps> = ({
  value,
  label,
  groupName,
  disabled = false,
  checked = false,
  customClassName = '',
  labelClasses = '',
  onSelect,
}) => {
  return (
    <div className={`alo-radio-button ${customClassName}`} role="radio" aria-checked={checked} key={value}>
      <input
        type="radio"
        id={`radio-${value}`}
        name={groupName}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          onSelect && onSelect(event);
        }}
      />
      {typeof label === 'string' ? (
        <label htmlFor={`radio-${value}`} className={labelClasses}>
          {label}
        </label>
      ) : (
        label
      )}
    </div>
  );
};

export default AloRadioButton;

type NonEmptyString<T extends string> = T extends '' ? never : T;

type RadioButtonProps = {
  value: string | number;
  label: string | ReactNode;
  disabled?: boolean; // Disable the entire radio group
  checked?: boolean;
  customClassName?: string; // Custom styles
  labelClasses?: string; // Custom styles
  onSelect?: (event: ChangeEvent<HTMLInputElement>) => void;
  // Callback on selection change
  groupName: NonEmptyString<string>; // Attribute groups related radio buttons together. Only one radio button within a group can be selected at a time.
};
